<template>
    <div>
        <div @click="showContext = !showContext" ref="contextButton" class="stories-context-opener context-opener"
            :class="{ 'context-opener-open': showContext }"></div>
        <div v-if="showContext" v-click-outside="{
            exclude: ['contextButton'],
            handler: 'clickOutsideContext'
        }" class="stories-context context">
            <span v-if="story.edit_end +
                Math.floor(timeDelta / 1000) >
                remain &&
                !initIsEmpty('init')
                " @click="edit" class="context-item stories-context-edit">
                {{ $t("header.headerEdit") }}
                <span class="context-item-light">
                    {{ getRemainHM(
                        story.edit_end +
                        Math.floor(timeDelta / 1000) -
                        remain,
                        true
                    ) }}
                </span>
            </span>
            <span @click="remove" class="context-item link-red">
                {{ $t("stories.deleteHistory") }}
            </span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { clickOutside } from '@/directives.js';
import { formatDateTime } from '@/mixins/formatDateTime';

export default {
    name: 'StoryContext',
    props: {
        story: {
            type: Object,
            required: true
        },
        i18n: Object,
    },
    mixins: [
        formatDateTime,
    ],
    data() {
        return {
            showContext: false,
            loader: false,
            remain: 0
        }
    },
    computed: {
        ...mapGetters({
            initIsEmpty: 'init/isEmpty',
            timeDelta: 'init/fetchTimeDelta'
        }),
    },
    created() {
        this.remain = Math.floor(+new Date() / 1000);
        setInterval(() => {
            this.remain = Math.floor(+new Date() / 1000);
        }, 1000);
    },
    methods: {
        edit() {
            this.showContext = false;
            this.$emit('edit');
        },
        remove() {
            this.$modal.show('dialog', {
                title: this.$t('albumEdit.warningText'),
                text: this.$t('stories.willDeleted'),
                buttons: [
                    {
                        title: this.$t('albumEdit.delete'),
                        handler: () => {
                            this.$store.dispatch('stories/remove', this.story.id)
                                .then(() => {
                                    this.showContext = false;
                                    this.$modal.hide('dialog');
                                })
                                .catch(() => {
                                    this.showContext = false;
                                    this.$modal.hide('dialog');
                                });
                        }
                    },
                    {
                        title: this.$t('albumEdit.cancel')
                    }
                ]
            })
        },
        clickOutsideContext() {
            this.showContext = false;
        }
    }
}
</script>
